import { CoreLoaderWrapperInner } from 'src/core/components/app/loaders/CoreLoaderWrapperInner'
import { useInitApplication } from 'src/core/hooks/services/useInitApplication'

import { ICoreLoaderWrapper } from './models/ICoreLoaderWrapper'

export const CoreLoaderWrapper = (props: ICoreLoaderWrapper) => {
  const { id, ownerId } = useInitApplication()
  if (!id || !ownerId) {
    return null
  }
  return <CoreLoaderWrapperInner {...props} />
}
